'use client';

import { AppBar, Toolbar } from '@mui/material';
import type { ReactNode } from 'react';

export const TopBar = ({ children, merchantLogoSrc }: { children: ReactNode; merchantLogoSrc?: string }) => {
	return (
		<>
			<AppBar position="fixed" style={{ backgroundColor: '#fff' }}>
				<Toolbar>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={merchantLogoSrc} style={{ maxHeight: '30px', padding: '0 20px' }} alt={'logo'} />
					{children}
				</Toolbar>
			</AppBar>
			<Toolbar />
		</>
	);
};
